export default __webpack_public_path__ + "static/media/vote_proxy_1.99da4cfa.jpg";